"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
const react_1 = __importDefault(require("react"));
const theme_1 = require("../../theme");
const Modal_styles_1 = require("./Modal.styles");
const Modal = ({ onClose, open, children, title }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null, open && (react_1.default.createElement(Modal_styles_1.BackgroundArea, { onClick: onClose },
        react_1.default.createElement(Modal_styles_1.ModalWindow, { onClick: (e) => e.stopPropagation(), "data-disable-document-scroll": open, "aria-labelledby": "modal-title" },
            react_1.default.createElement(Modal_styles_1.CloseCross, { onClick: onClose },
                react_1.default.createElement(theme_1.Close, null)),
            title && react_1.default.createElement(Modal_styles_1.Title, { id: "modal-title" }, title),
            react_1.default.createElement(Modal_styles_1.ContentContainer, null, children))))));
};
exports.Modal = Modal;
//# sourceMappingURL=Modal.js.map